import styled from "styled-components";

export const JeansTopSectionMainDiv = styled.div`
  max-width: 97vw;
  height: auto;
  margin: auto;
  margin-bottom: 5px;
`;
export const BigImageDiv = styled.div`
  display: block;
  max-width: 34vw;
  height: 97vh;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
`;

export const Paragraph = styled.div`
  max-width: 52vw;
  display: block;
  font-size: 10px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  margin-top: 50px;
  color: gray;
`;

export const BoldHeading = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: black;
`;

export const ImageDiv = styled.div`
  width: 58vw;
  height: 92vh;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  margin-top: 80px;
  margin-bottom: 30px;

  div {
    width: 50%;
    height: 100%;
  }
`;

export const IndividualItemDiv = styled.div`
  max-width: 15vw;
  height: 80vh;
  display: block;
  margin-bottom: 10px;
`;

export const IndividualItemImageDiv = styled.div`
  display: block;
  width: 100%;
  height: 73vh;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

export const IndividualItemInfoDiv = styled.div`
  display: block;
  width: 100%;
  height: auto;
  line-height: 16px;
  font-size: 11px;
  color: #7e7878;
  text-align: left;
`;

export const JeansNavbarMainDiv = styled.div`
  width: 96vw;
  top: 0;
  margin-right: auto;
  margin-left: 20px;
  display: flex;
  justify-content: space-between;
  height: 17vh;
  position: fixed;
  overflow: hidden;
  z-index: 1;
  div {
    display: flex;
    height: auto;
    color: #6e6969;
    font-size: 14px;
    /* position: relative; */
  }
`;
